import { Button, Input, Row, Tag } from 'antd'
import RefreshButton from '../../../elements/Buttons/RefreshButton'
import CustomSpin from '../../../elements/CustomSpin'
import EmployeesSelect from '../../../elements/Select/Employee/EmployeesSelect'
import GroupSelect from '../../../elements/Select/Groups/GroupsSelect'
import Authentication from '../../../modules/Authentication'
import moment from 'moment'
import React from 'react'
import { withRouter } from 'react-router-dom'
import Board from 'react-trello'

//color: rgb(255, 255, 255);

const auth = new Authentication()
const Search = Input.Search

function TaskSystemBoard (props) {
  const {
    data,
    fetching,
    onClickCard,
    onChangeCard,
    employee,
    group,
    hideCompany,
    onChangeCompanyCard,
    onChangeGroupCard,
    onFilteredChangeCard,
    handleOnSearch,
    changeView,
    listView,
    fetch,
    CustomCard,
  } = props

  return (
    <CustomSpin spinning={fetching}>
      <Row style={{ marginBottom: 20 }}>
        {!listView && (
          <>
            <RefreshButton onClick={fetch} size={'default'}/>
            <Button
              type={'primary'}
              icon={'plus'}
              size="small"
              onClick={() => {
                props.history.push({
                  pathname: `/operations/task-system/new/`,
                })
              }}
              style={{ marginLeft: 5, marginRight: 5, marginBottom: 0 }}>
              New Task
            </Button>
          </>
        )}
        <Button
          type={'dashed'}
          icon={listView ? 'appstore' : 'bars'}
          onClick={() => {
            changeView()
            fetch()
          }}
          style={{
            marginLeft: 5,
            marginRight: 5,
            marginBottom: 0,
            float: 'right',
          }}>
          View
        </Button>
        <Tag
          onClick={() => {
            onFilteredChangeCard([moment(), undefined], 'due.date', 'all')
          }}
          style={{ marginRight: 10 }}
          color="purple">
          Show All
        </Tag>
        <Tag
          onClick={() => {
            onFilteredChangeCard([moment(), moment()], 'due.date')
          }}
          style={{ marginRight: 10 }}
          color="magenta">
          Due Today
        </Tag>
        <Tag
          onClick={() => {
            onFilteredChangeCard([moment().startOf('w'), moment().endOf('w')], 'due.date')
          }}
          style={{ marginRight: 10 }}
          color="blue">
          Due This Week
        </Tag>
        <Tag
          onClick={() => {
            onFilteredChangeCard([moment().startOf('M'), moment().endOf('M')], 'due.date')
          }}
          style={{ marginRight: 10 }}
          color="geekblue">
          Due This Month
        </Tag>
        {hideCompany !== true && (
          <EmployeesSelect
            //value={employee ? employee : auth.getMember().fn}
            value={employee}
            onChange={onChangeCompanyCard}
            placeholder={'Filter by a Employee'}
            size={'small'}
            style={{ paddingRight: 20, width: 250 }}
          />
        )}
        <GroupSelect
          value={group}
          onChange={onChangeGroupCard}
          placeholder={'Filter by a Department'}
          size={'small'}
          style={{ paddingRight: 20, width: 250 }}
        />
        <Search
          placeholder="You can search Task Title or Description  ... "
          style={{ width: '500px' }}
          onSearch={(value) => handleOnSearch({ target: { value } })}
          onChange={handleOnSearch}
        />
      </Row>
      <Row>
        <Board
          data={data}
          tagStyle={{ fontSize: '80%' }}
          draggable
          collapsibleLanes
          laneStyle={{ maxWidth: 400, minWidth: 350, padding: 10 }}
          cardStyle={{
            backgroundColor: '#ffe',
            maxWidth: 390,
            minWidth: 340,
          }}
          //components={{Card: CustomCard}}
          onCardClick={onClickCard}
          handleDragEnd={onChangeCard}
        />
      </Row>
    </CustomSpin>
  )
}

export default withRouter(TaskSystemBoard)
